var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { SliceHeader } from './slice-header';
var cls = classNames('slice-latest-insights');
import { reverse, sortBy } from 'lodash';
import { classNames } from '@shapeable/utils';
import { EntityLinkButton } from './entity-link-button';
import { useEntity } from '../hooks/use-entity';
import { useLang } from '../hooks/use-lang';
import { useKnowledgeHubPage } from '../context/knowledge-hub-page-context';
import { useFeedEntries } from '../hooks/use-feed-entries';
import { usePosts } from '../hooks/use-posts';
import { EntityGrid } from './entity-grid';
export var SliceLatestInsightsDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme.UNIT(5))
});
var GridStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ViewAllButtonStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    align-self: center;\n  "], ["\n    align-self: center;\n  "])))
});
var FooterStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: ", ";\n  "])), theme.UNIT(4))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: styled(SliceHeader)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Grid: styled(EntityGrid)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  Footer: styled.div.attrs(cls.attr('footer'))(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles),
  ViewAllButton: styled(EntityLinkButton)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ViewAllButtonStyles)
};
export var SliceLatestInsights = function (props) {
  var className = props.className,
    children = props.children;
  var entity = useEntity(props.entity);
  var t = useLang();
  var knowledgeHubPage = useKnowledgeHubPage();
  var feedEntries = useFeedEntries();
  var posts = usePosts();
  var items = reverse(sortBy(__spreadArray(__spreadArray([], __read(feedEntries), false), __read(posts), false), 'published')).slice(0, 3);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Header, {
    showBottomDivider: false,
    entity: entity
  }), React.createElement(My.Grid, {
    desktopFullHdAutoColumns: 3,
    desktopLargeAutoColumns: 3,
    desktopAutoColumns: 3,
    tabletAutoColumns: 2,
    landscapeAutoColumns: 1,
    anyCardProps: {
      variant: 'chromeless'
    },
    items: items
  }), React.createElement(My.Footer, null, knowledgeHubPage && React.createElement(My.ViewAllButton, {
    entity: knowledgeHubPage
  }, t('View All'))));
};
SliceLatestInsights.defaultProps = SliceLatestInsightsDefaultProps;
SliceLatestInsights.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;